
/**
 * Централизованная система для построения всех типов Supabase URL
 */

import { SUPABASE_URL, SUPABASE_ANON_KEY } from './config';

// Базовые URL строители
export const buildRestApiUrl = (endpoint: string): string => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${SUPABASE_URL}/rest/v1/${cleanEndpoint}`;
};

export const buildStorageUrl = (bucket: string, path: string): string => {
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${SUPABASE_URL}/storage/v1/object/public/${bucket}/${cleanPath}`;
};

export const buildFunctionUrl = (functionName: string): string => {
  return `${SUPABASE_URL}/functions/v1/${functionName}`;
};

export const buildAuthUrl = (endpoint: string): string => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${SUPABASE_URL}/auth/v1/${cleanEndpoint}`;
};

export const buildRealtimeUrl = (): string => {
  return SUPABASE_URL.replace('https://', 'wss://') + '/realtime/v1/websocket';
};

// Специализированные строители
export const buildHealthCheckUrl = (service: 'api' | 'storage' | 'auth' | 'functions'): string => {
  switch (service) {
    case 'api':
      return buildRestApiUrl('');
    case 'storage':
      return `${SUPABASE_URL}/storage/v1/bucket`;
    case 'auth':
      return buildAuthUrl('settings');
    case 'functions':
      return `${SUPABASE_URL}/functions/v1/`;
    default:
      return SUPABASE_URL;
  }
};

// Утилиты для заголовков
export const getStandardHeaders = (): Record<string, string> => ({
  'Content-Type': 'application/json',
  'apikey': SUPABASE_ANON_KEY,
  'Authorization': `Bearer ${SUPABASE_ANON_KEY}`
});

export const getStorageHeaders = (): Record<string, string> => ({
  'apikey': SUPABASE_ANON_KEY,
  'Authorization': `Bearer ${SUPABASE_ANON_KEY}`
});

// Экспорт базового URL для обратной совместимости
export { SUPABASE_URL, SUPABASE_ANON_KEY };
